import React, { useState } from 'react';
import Editor from '../Editor';
import useLocalStorage from '../../hooks/useLocalStorage';

function FizzBuzz() {
    const [script, setScript] = useLocalStorage('fizzBuzzScript', 'print("Hello World");');
    const [resultText, setResultText] = useState('');
    const [syntaxError, setSyntaxError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resultTextCss, setResultTextCss] = useState('');
    const [srcDoc, setSrcDoc] = useState('');
    const CORRECTRESULT = ['1', '2', 'Fizz', '4', 'Buzz', 'Fizz', '7', '8', 'Fizz', 'Buzz', '11', 'Fizz', '13', '14', 'FizzBuzz', '16', '17', 'Fizz', '19', 'Buzz', 'Fizz', '22', '23', 'Fizz', 'Buzz', '26', 'Fizz', '28', '29', 'FizzBuzz', '31', '32', 'Fizz', '34', 'Buzz', 'Fizz', '37', '38', 'Fizz', 'Buzz', '41', 'Fizz', '43', '44', 'FizzBuzz', '46', '47', 'Fizz', '49', 'Buzz', 'Fizz', '52', '53', 'Fizz', 'Buzz', '56', 'Fizz', '58', '59', 'FizzBuzz', '61', '62', 'Fizz', '64', 'Buzz', 'Fizz', '67', '68', 'Fizz', 'Buzz', '71', 'Fizz', '73', '74', 'FizzBuzz', '76', '77', 'Fizz', '79', 'Buzz', 'Fizz', '82', '83', 'Fizz', 'Buzz', '86', 'Fizz', '88', '89', 'FizzBuzz', '91', '92', 'Fizz', '94', 'Buzz', 'Fizz', '97', '98', 'Fizz', 'Buzz'];

    function executeScript() {
        setSyntaxError(false);
        setErrorMessage('');
        setResultText('');
        try {
            const scriptFunction = new Function(`
                let output = [];
                function print(text) {
                    output.push(text.toString());
                }
                ${script}
                return output;
            `);

            const output = scriptFunction();
            const formattedOutput = output.map(line => `<div>${line}</div>`).join('');
            setSrcDoc(formattedOutput);
            checkPassed(output);
        } catch (e) {
            setSyntaxError(true);
            setResultTextCss('');
            setResultText('Ergebnis kann nicht ausgewertet werden, da dein Code noch einen oder mehrere Syntaxfehler hat:');
            setErrorMessage(e.message);
            setSrcDoc(`<div style="color: red;">Fehler: ${e.message}</div>`);
        }
    }

    function checkPassed(output) {
        for (let i = 0; i < CORRECTRESULT.length; i++) {
            if (CORRECTRESULT[i] !== output[i]) {
                setResultTextCss('error-message');
                setResultText(
                    `Deine Lösung ist falsch. Erster Fehler tritt an der Stelle: ${i + 1}, hier wurde: ${CORRECTRESULT[i]} erwartet, dein Ergebnis ist allerdings: ${output[i]}`
                );
                return;
            }
        }
        setResultTextCss('success-result');
        setResultText("Deine Lösung ist korrekt");
    }

    return (
        <>
            <div className="aufgaben-container">
                <h2>FizzBuzz</h2>
                <h3>Aufgabenstellung:</h3>
                Hier kannst du den FizzBuzz-Algorithmus implementieren. Was ist der Fizz-Buzz-Algorithmus? Hier ist
                die fachliche Beschreibung:
                <br/><br/>
                1) Schreibe ein Programm, das die Zahlen von 1 bis 100 ausgibt <br/>
                2) Für Vielfache von drei gib statt der Zahl „Fizz“ aus <br/>
                3) Für Vielfache von fünf „Buzz“ <br/>
                4) Für Zahlen, die Vielfache von drei und fünf sind, gib statt der Zahl „FizzBuzz“ aus<br/>
                <br/>
                Um die Implementierung zu vereinfachen, gibt es eine „print()“-Funktion, die du für die Ausgabe
                verwenden kannst. Wenn du etwas implementiert hast kannst deinen Code jederzeit ausführen und
                bekommst dann die Ausgabe deines Algorithmus angezeigt.
            </div>
            <div className="pane top-pane">
                <Editor
                    language="javascript"
                    value={script}
                    onChange={setScript}
                    editorKey="fizzBuzzScript"
                />
            </div>
            <button className="submit-code-button" onClick={executeScript}>▶ Code ausführen</button>
            <div className="ergebnis-text">
                Ergebnis: <br />
                <div className={resultTextCss}>{resultText}</div>
                {syntaxError && <div className="error-message">{errorMessage}</div>}
            </div>
            <div className="result-frame">
                <iframe
                    title="console-output"
                    srcDoc={srcDoc}
                    sandbox="allow-scripts"
                    width="100%"
                    height="100%"
                />
            </div>
        </>
    );
}

export default FizzBuzz;



/*
Lösung:
for (let i = 1; i <= 100; i++) {
  let tmp = "";
  if (i % 3 === 0) {
    tmp += "Fizz";
  }
  if (i % 5 === 0) {
    tmp += "Buzz";
  }
  print(tmp || i);
}
 */